import { createContext, useContext } from "react";

export interface InvoiceDrawerReadyContextValue {
  readyPath: string | null;
  setReadyPath: (path: string | null) => void;
}

export const InvoiceDrawerReadyContext =
  createContext<InvoiceDrawerReadyContextValue | null>(null);

export function useInvoiceDrawerReady() {
  return useContext(InvoiceDrawerReadyContext);
}
